import { useRouter } from 'next/router'

// Components
import Button from '@/components/newButton/Button'
import ButtonCall from '@/components/puppyProfile/lib/buttonCall'
import s from './Questions.module.scss'

export default function Questions() {
  const { push } = useRouter()

  return (
    <div className={s.questions}>
      <h2>Any questions? Get in touch!</h2>

      <p>
        We are here to support you every step of the way. Our concierge service
        is here daily to answer your questions!
        <br />
        <br />
        Chat or speak with our team <span>Mon-Sat 9a-9p ET.</span>
      </p>

      <div className={s.buttons}>
        <ButtonCall />
      </div>

      <h4>Ready to find your new best friend?</h4>

      <div className={s.search}>
        <Button
          title="Search puppies"
          theme={['pink-solid', 'medium']}
          onClick={() => {
            push(`${process.env.NEXT_PUBLIC_ROOT_URL}/search`)
          }}
        />
      </div>
    </div>
  )
}
